module.exports = __webpack_public_path__ + "img/Pattern04.79a43545.png";